(ns practitest.frontend.components2.requirement-testing-status)

;; Some hardcoded issues statuses colors as in figma:
;;https://www.figma.com/file/0aTwitb3NTlNHmCpBFb3XA/Practitest-UX-Clients?type=design&node-id=2869-133792&mode=dev

(def statuses-map
  {"PASSED"      {:label "PASSED"
                  :color "var(--pt-color-success)"}
   "FAILED"      {:label "FAILED"
                  :color "var(--pt-color-error)"}
   "BLOCKED"     {:label "BLOCKED"
                  :color "var(--pt-color-warning)"}
   "STARTED"     {:label "STARTED"
                  :color "var(--pt-color-status-not-completed)"}
   "NO RUN"      {:label "NO RUN"
                  :color "var(--pt-color-status-no-run)"}
   "NOT COVERED" {:label "NOT COVERED"
                  :color "var(--pt-color-in-progress)"}
   "N/A"         {:label "N/A"
                  :color "var(--pt-color-status-na)"}})

(def default-color "var(--pt-color-border-light)")

(defn get-status-label
  [status]
  (when status
    (or (:label (get statuses-map status))
        ;; Use label itself here
        status)))

(defn get-status-color
  [status]
  (or (:color (get statuses-map status))
      default-color))

(defn requirement-status-component
  [status]
  [:<>
   [:span.status-indicator
    {:style {:color (get-status-color status)}}]
   (get-status-label status)])
